export default __webpack_public_path__ + "static/media/generators.bf0c6519.svg";